module.exports = __webpack_public_path__ + "static/media/banesco-icon.d63123bd.svg";